import React from 'react'
import { useDispatch } from 'react-redux'
import { setDrawer } from 'slices/drawer'
import { STATICS } from 'statics'
import { DRAWER_KEY, FIREBASE_EVENTS } from 'app-constants'
import { useFirebaseEvent } from 'hooks'
import { BaseCard } from '../base-card'

export function PasswordChange() {
  const dispatch = useDispatch()
  const { sendEvent } = useFirebaseEvent()

  function handleClick() {
    sendEvent(FIREBASE_EVENTS.CLICK_ON_CHANGE_SAC_PASSWORD)
    dispatch(setDrawer(DRAWER_KEY.PASSWORD))
  }

  return <BaseCard onClick={handleClick} text='Alterar senha' icon={<STATICS.KEY />} />
}
